export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const setPaymentMethods = (paymentMethods) => ({ type: SET_PAYMENT_METHODS, paymentMethods });
